export default __webpack_public_path__ + "/dist/images/3600942.efad8b8ac6e34790e4bd86f7383cb75b.png";